// TODO: swap in ua-parser-js
import isMobile from 'ismobilejs'

export default () => isMobile(window.navigator.userAgent).any
